import { ujsAjaxParams } from "./utils";

$(function() {
  const
    modal = $('.ti-modal'),
    modalOpen = function() {
      ahoy.start();
      ahoy.track('Popup - view');
      modal.css('display', 'flex');
    },
    modalClose = function() {
      ahoy.start();
      ahoy.track('Popup - close');
      modal.css('display', 'none');
    };
  if (modal.length > 0 && !currentUser.id) {
    setTimeout(modalOpen, config.modalDelay);
  }
  $('.js-ti-modal-close').on('click', modalClose);

  const captureModalLead = function(email, location) {
    $('.ti-modal form')
      .on('ajax:success', function(ujsEvent) {
        const { data } = ujsAjaxParams(ujsEvent)
        $('.ti-modal input').hide();
        const
          message = 'Thank you! You will now receive our daily summary for tech news.',
          baseUrl = xhr.currentTarget.baseURI;
        $('.ti-modal .output')
          .addClass('has-success')
          .text(message)
          .animate({ opacity: '1' }, 400, 'linear');
        ahoy.start();
        ahoy.track('lead-conversion', {
          'url': window.location.href
        });
        analytics.track('lead-conversion');
        setTimeout(function() {
          modalClose();
          window.location.href = baseUrl;
        }, 3000);
      })
      .on('ajax:error', function(e, xhr, status, error) {
        const errorMessage = xhr.responseJSON.message || 'There was an error. Please try again.';
        if (xhr.status == 422) {
          const newPath = xhr.responseJSON.user_type === 'subscriber' ? '/sessions/new' : '/settings/email-preferences';
          window.location.href = window.location.origin + newPath;
        }
        else {
          $('.ti-modal .output')
            .addClass('has-error')
            .text(errorMessage)
            .animate({ opacity: '1' }, 400, 'linear');
        }
      });
  }

  $('.ti-modal .submit').click(function(e) {
    const
      email = $('.email').val(),
      location = window.location.pathname;
    captureModalLead(email, location);
  });
});
